import {
    Grid,
    Box,
    Checkbox,
    FormControlLabel,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    FormControl,
    Paper,
    TextareaAutosize
} from "@mui/material";
import { useState, Fragment } from 'react';
import Swal from "sweetalert2";
import ClearIcon from '@mui/icons-material/Clear';
import DialogText from "./DialogText";

function TestRegister() {

    const [scroll, setScroll] = useState('paper');

    const [agree1, setAgree1] = useState(false);
    const openAgree1 = () => {
        setAgree1(true);
    };
    const closeAgree1 = () => {
        setAgree1(false);
        if (checked === true) {
            setChecked(checked);
        }
    };

    const [checked, setChecked] = useState(false);
    const confirmAgree1 = () => {
        if (checked === false){
          setChecked(!checked);
        }
        closeAgree1();
      };
      const changeValue1 = (e) => {
        setChecked(e.value);
      };

    const [agree2, setAgree2] = useState(false);
    const openAgree2 = () => {
        setAgree2(true);
    };
    const closeAgree2 = () => {
        setAgree2(false);
    };

    const [agree3, setAgree3] = useState(false);
    const openAgree3 = () => {
        setAgree3(true);
    };
    const closeAgree3 = () => {
        setAgree3(false);
    };

    const [agree4, setAgree4] = useState(false);
    const openAgree4 = () => {
        setAgree4(true);
    };
    const closeAgree4 = () => {
        setAgree4(false);
    };

    const [agree5, setAgree5] = useState(false);
    const openAgree5 = () => {
        setAgree5(true);
    };
    const closeAgree5 = () => {
        setAgree5(false);
    };

    

    return (
        <Grid
            container
            height="100%"
            direction="column"
            justifyContent="space-around"
            // alignItems="space-between"
            >
                <Grid className="header"
                    container
                    direction="row"
                    justifyContent="space-between"
                    width="100%"
                    height="10%"
                    style={{
                        padding: "5px",
                        fontSize: "20px",
                        background: "#0092a2",
                        color: "white",
                    }}
                >
                    회원가입
                    <ClearIcon></ClearIcon>
                </Grid>
            <Grid
                container
                display="flex"
                direction="column"
                justifyContent="space-around"
                alignItems="center"
                >
                <Box sx={{margin: "20px"}}>
                    서비스 이용약관에 대한 동의(필수)
                </Box>
                <Box sx={{height: "70vh", overflow: "scroll", padding: "10px", marginBottom: "20px"}}>
                <DialogText></DialogText>
                </Box>
                <Button variant="contained">동의 후 다음 단계로</Button>
            </Grid>
            
        </Grid>
    )
}
export default TestRegister;